import * as React from 'react';
import { Component } from 'react';
import { AppUser } from '../../../../../App';
import { History, Location } from 'history';
import {
  ColumnDefinition,
  convertToFilterWithPlus,
  getFilters,
  getOrder,
  getPagesCount,
  getSearchFilter,
  getSearchOrder,
  getServerFieldSectionWhere,
  getServerQueryFilter,
  isFilterExist,
  isSortExist,
  TABLE_SORT_DIRECTION,
} from '../../../../../../../helpers/table';
import { School } from '../../../../../../../models/schools';
import { DATE_INTERVAL, FILTER_TYPE, FIRST_PAGE, LIMIT } from '../../../../../../../consts/table';
import { parse } from 'query-string';
import { getSchool } from '../../../../../../../services/superadmin/schools';
import * as Promise from 'bluebird';
import {
  addSchoolUsers,
  deleteSchoolUser,
  getAllSchoolUsers,
  getSchoolUsers,
  getSchoolUsersCount,
  updateSchoolUser,
} from '../../../../../../../services/superadmin/schoolUsers';
import * as propz from 'propz';
import { SimpleModal } from '../../../../../../../components/SimpleModal/SimpleModal';
import { Loader } from '../../../../../../../components/Loader/Loader';
import { Grid } from '../../../../../../../components/Grid/Grid';
import { SchoolUsersForm } from './SchoolUsersForm/SchoolUsersForm';
import { SchoolStudentsForm } from '../SchoolStudents/SchoolStudentsForm/SchoolStudentsForm';
import { getIsDataNotificationEnabled, getIsSchoolAdmin } from '../../../../../../../helpers/accessor';
import { getSelectOptionForYesOrNo } from '../../../../../../../helpers/select';

const COLUMNS: ColumnDefinition[] = [
  {
    text: 'First name',
    field: 'firstName',
    isSort: true,
    type: FILTER_TYPE.TEXT,
    accessor: ['firstName'],
  },
  {
    text: 'Last name',
    field: 'lastName',
    isSort: true,
    type: FILTER_TYPE.TEXT,
    accessor: ['lastName'],
  },
  {
    text: 'Email',
    field: 'email',
    isSort: true,
    type: FILTER_TYPE.TEXT,
    accessor: ['email'],
  },
  {
    text: 'Phone',
    field: 'mobilePhone',
    isSort: true,
    type: FILTER_TYPE.TEXT,
    accessor: ['mobilePhone'],
  },
  {
    text: 'Notifications Enabled',
    field: 'isDataNotificationEnabled',
    isSort: false,
    type: FILTER_TYPE.SELECT,
    accessor: getIsDataNotificationEnabled,
  },
  {
    text: 'Admin Status',
    field: 'isSchoolAdmin',
    isSort: false,
    type: FILTER_TYPE.SELECT,
    accessor: getIsSchoolAdmin,
  },
];

interface Props {
  user: AppUser;
  history: History;
  location: Location;
}

interface State {
  items: any[];
  currentPage: number;
  selectedItems: any[];
  sortDirection: TABLE_SORT_DIRECTION;
  sortColumnsName: string;
  isShowFilter: boolean;
  isDataFiltered: boolean;
  filters: any;
  isLoading: boolean;
  isSelectAllChecked: boolean;
  total: number;
  basePath: string;
  schoolItem: School;
  isSchoolUserFormModalOpen: boolean;
  isConfirmationModalOpen: boolean;
  isErrorModalOpen: boolean;
  errorMessage: string;
}

export class SchoolUsers extends Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      items: [],
      currentPage: FIRST_PAGE,
      selectedItems: [],
      sortDirection: '',
      sortColumnsName: '',
      isShowFilter: false,
      isDataFiltered: false,
      filters: {},
      isLoading: false,
      isSelectAllChecked: false,
      total: 0,
      basePath: '',
      schoolItem: undefined,
      isSchoolUserFormModalOpen: false,
      isConfirmationModalOpen: false,
      isErrorModalOpen: false,
      errorMessage: '',
    };
  }

  getSchoolId(): string {
    const { history } = this.props;
    const search = parse(history.location.search);
    return search.school as string;
  }

  componentDidMount() {
    this.setState({
      isLoading: true,
    });
    this.setAdditionalItems().then(res => {
      this.setItems();
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.location.search !== this.props.location.search) {
      this.setState({
        isLoading: true,
      });
      this.setItems();
    }
  }

  setAdditionalItems() {
    const { user } = this.props;
    const schoolId = this.getSchoolId();

    return getSchool(user, schoolId).then(schoolItem => {
      this.setState({
        schoolItem: schoolItem,
      });

      return true;
    });
  }

  setItems() {
    const { history, user } = this.props;

    const search = parse(history.location.search);
    const page = typeof search.page !== 'undefined' ? Number(search.page) : FIRST_PAGE;

    let sortDirection = '';
    let sortColumnsName = '';

    if (typeof search.order === 'string') {
      [sortColumnsName, sortDirection] = search.order.split(':');
    }

    const sortByFieldExist = sortColumnsName !== '';
    const sortDirectionExist = sortDirection !== '';

    const filters = getFilters(COLUMNS, search);

    const isShowFilter = isFilterExist(filters);
    const isDataFiltered = isFilterExist(filters);

    const where = getServerFieldSectionWhere(filters);

    const order = sortByFieldExist && sortDirectionExist ? `${sortColumnsName} ${sortDirection}` : undefined;
    const serverQueryFilter = getServerQueryFilter(page, where, order);

    const schoolId = this.getSchoolId();

    const getItemsPromise = getSchoolUsers(user, schoolId, serverQueryFilter);
    const getItemsCountPromise = getSchoolUsersCount(user, schoolId, where);

    const promises = [getItemsCountPromise, getItemsPromise];

    return Promise.all(promises).then(([countObj, items]) => {
      this.setState({
        currentPage: page,
        sortDirection: sortDirection as TABLE_SORT_DIRECTION,
        sortColumnsName: sortColumnsName,
        isShowFilter: isShowFilter,
        isDataFiltered: isDataFiltered,
        filters: filters,
        items: items,
        total: countObj.count,
        basePath: history.location.pathname,
        isLoading: false,
      });

      return true;
    });
  }

  setCurrentPageParams = (currentPage: number): void => {
    let search = [];

    const { filters, sortColumnsName, sortDirection } = this.state;

    if (currentPage !== 1) {
      search.push(`page=${currentPage}`);
    }

    if (isSortExist(sortDirection, sortColumnsName)) {
      search.push(getSearchOrder(sortDirection, sortColumnsName));
    }

    const isFilter = isFilterExist(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    const schoolId = this.getSchoolId();

    const { history } = this.props;

    this.props.history.push({
      pathname: this.state.basePath,
      search: `school=${schoolId}&${search.join('&')}`,
      state: history.location.state,
    });
  };

  onItemClick = (index: number): void => {
    const { items, selectedItems } = this.state;
    const selectedItem = items[index];

    const selectedItemIndex = selectedItems.findIndex(item => selectedItem.id === item.id);
    let selectedItemsUpdated = [...selectedItems];

    if (selectedItemIndex !== -1) {
      selectedItemsUpdated.splice(selectedItemIndex, 1);
    } else {
      selectedItemsUpdated.push(selectedItem);
    }

    this.setState({
      selectedItems: selectedItemsUpdated,
    });
  };

  onSelectAllOnPageClick = (): void => {
    const { items, selectedItems } = this.state;

    const itemsFiltered = items.filter(item => {
      return selectedItems.every(selectedItem => selectedItem.id !== item.id);
    });

    const selectedItemsNext = [...selectedItems, ...itemsFiltered];

    this.setState({
      selectedItems: selectedItemsNext,
      isSelectAllChecked: true,
    });
  };

  onSelectAllClick = (): void => {
    const { selectedItems, filters } = this.state;

    this.setState({
      isLoading: true,
    });

    const user = this.props.user;

    const where = getServerFieldSectionWhere(filters);

    const schoolId = this.getSchoolId();

    getAllSchoolUsers(user, schoolId, where).then(items => {
      const itemsFiltered = items.filter(item => {
        return selectedItems.every(selectedItem => selectedItem.id !== item.id);
      });

      const selectedItemsNext = [...selectedItems, ...itemsFiltered];

      this.setState({
        selectedItems: selectedItemsNext,
        isSelectAllChecked: true,
        isLoading: false,
      });
    });
  };

  onUnselectAllClick = (): void => {
    this.setState({
      selectedItems: [],
      isSelectAllChecked: false,
    });
  };

  onTableSortClick = (sortField: string): void => {
    const { sortDirection, sortColumnsName, filters } = this.state;

    const order = getOrder(sortField, sortDirection, sortColumnsName);

    let search = [];
    search.push(`order=${sortField}:${order}`);

    const isFilter = isFilterExist(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    const schoolId = this.getSchoolId();

    const { history } = this.props;

    this.props.history.push({
      pathname: this.state.basePath,
      search: `school=${schoolId}&${search.join('&')}`,
      state: history.location.state,
    });
  };

  onTableFilterChange = (event, filterField: string, options?): void => {
    const filterValue = event.target.value;
    const filters = this.state.filters;
    const currentFilterField = filters[filterField];

    let nextFilters = { ...filters };

    if (typeof options !== 'undefined') {
      switch (options) {
        case DATE_INTERVAL.FROM:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              from: filterValue,
            },
          };
          break;
        case DATE_INTERVAL.TO:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              to: filterValue,
            },
          };
          break;
      }
    } else {
      const filter = COLUMNS.find(col => col.field === filterField);
      const filterType = filter.type;

      if (filterType === FILTER_TYPE.MULTISELECT) {
        const options = event.target.options;
        const value = [];
        for (let i = 0; i < options.length; i++) {
          if (options[i].selected) {
            value.push(options[i].value);
          }
        }
        nextFilters = {
          ...nextFilters,
          [filterField]: value,
        };
      } else {
        nextFilters = {
          ...nextFilters,
          [filterField]: filterValue,
        };
      }
    }

    this.setState({
      filters: nextFilters,
    });
  };

  onApplyFilterClick = (): void => {
    const { filters, sortDirection, sortColumnsName } = this.state;
    let search = [];

    if (isSortExist(sortDirection, sortColumnsName)) {
      search.push(getSearchOrder(sortDirection, sortColumnsName));
    }

    const isFilter = isFilterExist(filters);

    const filtersConverted = convertToFilterWithPlus(filters);

    if (isFilter) {
      search.push(getSearchFilter(filtersConverted));
    }

    this.setState({
      selectedItems: [],
      isSelectAllChecked: false,
    });

    const schoolId = this.getSchoolId();

    const { history } = this.props;

    this.props.history.push({
      pathname: this.state.basePath,
      search: `school=${schoolId}&${search.join('&')}`,
      state: history.location.state,
    });
  };

  onClearFilterClick = (): void => {
    this.setState({
      selectedItems: [],
      isSelectAllChecked: false,
    });

    const schoolId = this.getSchoolId();

    const { history } = this.props;

    this.props.history.push({
      pathname: this.state.basePath,
      search: `school=${schoolId}`,
      state: history.location.state,
    });
  };

  onTableFilterClick = (event): void => {
    event.preventDefault();

    const isShowFilter = this.state.isShowFilter;

    this.setState({
      isShowFilter: !isShowFilter,
    });
  };

  goBack = () => {
    const { history, location } = this.props;
    const { state } = location;
    const { search } = state as any;
    const schoolId = this.getSchoolId();

    history.push({
      pathname: '/schools',
      search: search,
      state: { schoolId: schoolId },
    });
  };

  onCancelButtonClick = () => {
    this.setState({
      isSchoolUserFormModalOpen: false,
    });
  };

  onCloseErrorClick = () => {
    this.setState({
      isErrorModalOpen: false,
      errorMessage: '',
      isLoading: true,
    });
    this.setItems();
  };

  onSubmitForm = data => {
    const { selectedItems, total } = this.state;
    const { user } = this.props;

    const schoolId = this.getSchoolId();

    this.setState({
      isLoading: true,
    });

    const dataToTransfer = {
      ...data,
      schoolId: schoolId,
    };

    if (selectedItems.length === 1) {
      const schoolUser = selectedItems[0];
      const { id } = schoolUser;

      updateSchoolUser(user, schoolId, id, dataToTransfer)
        .then(res => {
          this.setState({
            isSchoolUserFormModalOpen: false,
            selectedItems: [res],
            isSelectAllChecked: false,
          });
          this.setItems();
        })
        .catch(error => {
          const errorText = propz.get(error, ['response', 'data', 'details', 'text'], '');
          console.error(errorText);
          this.setState({
            isLoading: false,
            isSchoolUserFormModalOpen: false,
            isErrorModalOpen: true,
            errorMessage: errorText,
          });
        });
    } else {
      addSchoolUsers(user, schoolId, dataToTransfer)
        .then(res => {
          const lastPage = getPagesCount(total + 1, LIMIT);
          this.setState({
            isSchoolUserFormModalOpen: false,
            selectedItems: [res],
            isSelectAllChecked: false,
          });
          this.setCurrentPageParams(lastPage);
          this.setItems();
        })
        .catch(error => {
          const errorText = propz.get(error, ['response', 'data', 'details', 'text'], '');
          console.error(errorText);
          this.setState({
            isLoading: false,
            isSchoolUserFormModalOpen: false,
            isErrorModalOpen: true,
            errorMessage: errorText,
          });
        });
    }
  };

  renderFormModal(): React.ReactNode {
    const { isSchoolUserFormModalOpen, selectedItems } = this.state;

    if (selectedItems.length === 1) {
      const schoolUser = selectedItems[0];
      return (
        <SimpleModal isOpen={isSchoolUserFormModalOpen}>
          <SchoolUsersForm schoolUser={schoolUser} onCancel={this.onCancelButtonClick} onSubmit={this.onSubmitForm} />
        </SimpleModal>
      );
    } else {
      return (
        <SimpleModal isOpen={isSchoolUserFormModalOpen}>
          <SchoolUsersForm onCancel={this.onCancelButtonClick} onSubmit={this.onSubmitForm} />
        </SimpleModal>
      );
    }
  }

  onCreateSchoolUserClick = () => {
    this.setState({
      isSchoolUserFormModalOpen: true,
    });
  };

  onEditSchoolUserClick = () => {
    this.setState({
      isSchoolUserFormModalOpen: true,
    });
  };

  showConfirmationModal = () => {
    this.setState({
      isConfirmationModalOpen: true,
    });
  };

  hideConfirmationModal = () => {
    this.setState({
      isConfirmationModalOpen: false,
    });
  };

  renderConfirmationModal(): React.ReactNode {
    const { isConfirmationModalOpen, selectedItems } = this.state;

    const schoolUser = selectedItems[0];
    return (
      <SimpleModal
        isOpen={isConfirmationModalOpen}
        title={'Confirmation'}
        body={`Are you sure you want to remove ${
          selectedItems.length === 1
            ? `user ${schoolUser.firstName} ${schoolUser.lastName}`
            : `${selectedItems.length} users`
        }?`}
        buttonText={'Remove'}
        buttonCancelText={'Cancel'}
        onButtonClick={this.onDeleteSchoolUsersClick}
        onCloseClick={this.hideConfirmationModal}
      />
    );
  }

  onDeleteSchoolUsersClick = () => {
    const { selectedItems } = this.state;
    const { user } = this.props;

    this.setState({
      isLoading: true,
      isConfirmationModalOpen: false,
    });

    const schoolId = this.getSchoolId();

    Promise.all(selectedItems.map(selectedItem => deleteSchoolUser(user, schoolId, selectedItem.id))).then(res => {
      this.setState({
        selectedItems: [],
        isSelectAllChecked: false,
      });

      this.setItems();
    });
  };

  renderSendingError(): React.ReactNode {
    const { errorMessage, isErrorModalOpen } = this.state;

    return (
      <SimpleModal
        isOpen={isErrorModalOpen}
        title={'Error'}
        body={errorMessage}
        buttonCancelText={'Ok'}
        onCloseClick={this.onCloseErrorClick}
      />
    );
  }

  render() {
    const {
      items,
      sortDirection,
      sortColumnsName,
      isShowFilter,
      isDataFiltered,
      selectedItems,
      filters,
      isLoading,
      isSelectAllChecked,
      currentPage,
      total,
      schoolItem,
      isSchoolUserFormModalOpen,
      isConfirmationModalOpen,
      isErrorModalOpen,
    } = this.state;

    if (isLoading) {
      return <Loader />;
    }

    const classes =
      isSchoolUserFormModalOpen || isConfirmationModalOpen || isErrorModalOpen ? 'mt-3 modal-open' : 'mt-3';

    const actionItems = [
      {
        itemText: 'Add user',
        onItemClick: this.onCreateSchoolUserClick,
        isActive: selectedItems.length === 0,
      },
      {
        itemText: 'Edit user',
        onItemClick: this.onEditSchoolUserClick,
        isActive: selectedItems.length === 1,
      },
      {
        itemText: selectedItems.length === 1 ? 'Delete user' : 'Delete users',
        onItemClick: this.showConfirmationModal,
        isActive: selectedItems.length > 0,
      },
    ];

    const gridTitle = typeof schoolItem !== 'undefined' ? `${schoolItem.name} / Users` : '';

    const filterOptions = {
      isDataNotificationEnabled: getSelectOptionForYesOrNo(),
      isSchoolAdmin: getSelectOptionForYesOrNo(),
    };

    return (
      <div className={classes}>
        {/*Place for render modal windows*/}
        {this.renderSendingError()}
        {this.renderFormModal()}
        {this.renderConfirmationModal()}
        <div className="row">
          <div className="col-md-12">
            <Grid
              dataItems={items}
              filters={filters}
              currentPage={currentPage}
              total={total}
              isSelectAllChecked={isSelectAllChecked}
              isDataFiltered={isDataFiltered}
              sortDirection={sortDirection}
              sortColumnsName={sortColumnsName}
              isShowFilter={isShowFilter}
              dataItemsSelected={selectedItems}
              columns={COLUMNS}
              actionItems={actionItems}
              options={filterOptions}
              onItemClick={this.onItemClick}
              onSortClick={this.onTableSortClick}
              onApplyFilterClick={this.onApplyFilterClick}
              onClearFilterClick={this.onClearFilterClick}
              onTableFilterChange={this.onTableFilterChange}
              onTableFilterClick={this.onTableFilterClick}
              setCurrentPageParams={this.setCurrentPageParams}
              onSelectAllClick={this.onSelectAllClick}
              onSelectAllOnPageClick={this.onSelectAllOnPageClick}
              onUnselectAllClick={this.onUnselectAllClick}
              gridTitle={gridTitle}
              goBack={this.goBack}
            />
          </div>
        </div>
      </div>
    );
  }
}
